<template>
  <a-spin size="large" :spinning="loading">
    <div class="home">
      <div class="tips" v-if="$route.query.expried == '1'">
        <div class="tips-cont" :class="[lang]">
          <a-icon
            class="icon"
            type="exclamation-circle"
            :style="{ marginLeft: lang == 'AR' ? '10px' : '0px' }"
          />{{ $t("freeTrialTips") }}
        </div>
      </div>

      <div class="wrap-step">
        <Step
          :current="$route.query.isfromCamp == 1 ? 1 : 0"
          :isfromCamp="$route.query.isfromCamp == 1 ? true : false"
        ></Step>
      </div>
      <div class="wrap pricing" :class="[lang]">
        <div class="pricing_container">
          <div class="chooseTips">
            <div class="title">{{ $t("Choosetheright") }}</div>
            <div class="subTi">
              {{ $t("publishyourcampaign") }}
            </div>
          </div>
          <div class="baozhang">
            <p class="t1">
              <a-icon type="safety-certificate" class="icon" />
              {{ $t("fourMoth")
              }}<a-tooltip placement="bottom" overlayClassName="customTip">
                <template slot="title">
                  <p style="font-size: 12px">
                    {{ $t("Termsandconditionsapply") }}<br />
                    • {{ $t("Aleast10campaigns") }} <br />
                    • {{ $t("Atleasttwocampaigns") }}
                    <br />
                    • {{ $t("Noleadsweregenerated") }}
                    <br />
                    • {{ $t("Thispolicyapplies") }}
                  </p>
                </template>
                <span
                  ><a-icon
                    type="exclamation-circle"
                    style="color: #fff; margin-left: 5px"
                  />
                </span>
              </a-tooltip>
              <!-- {{ $t("Guarantee") }} -->
            </p>
            <p class="t2" v-html="formatEmail2()"></p>
          </div>
          <div class="wrap-btn">
            <div class="pricing_monthly">
              <div
                class="pricing_monthlyopan"
                style="direction: ltr"
                :class="{ active: active }"
              >
                <span @click="tabHandler()" :class="lang">{{
                  $t("Monthly")
                }}</span
                ><span @click="tabHandler()" :class="lang">{{
                  $t("Annually")
                }}</span>
              </div>
            </div>
            <div class="enterprise-header">
              <h2 :class="[lang]">
                StrategyBrain
                <span class="enterprise-badge">{{ $t("Enterprise") }}</span>
              </h2>
            </div>
          </div>
          <div
            class="main-wrap"
            :class="{ incluedFree: planList.length && planList[0].length == 5 }"
          >
            <div class="left-box">
              <div class="pric_switchingall">
                <div
                  title="Monthly"
                  class="pric_switchingitem"
                  :class="{ show: active }"
                >
                  <div class="pric_switchinglist">
                    <div
                      class="price_swlistitem price_swlistitemlie1"
                      :style="{ marginRight: lang == 'AR' ? 0 : '16px' }"
                      style="display: none"
                    >
                      <div class="priceitemtop">
                        <h2 class="priceitemtop_title">{{ $t("Manual") }}</h2>
                        <div class="priceitemtop_desc">
                          {{ $t("ReducecostsandImprove") }}
                        </div>
                        <div class="priceitemtop_price">
                          <b>$</b><big>5000</big
                          ><span
                            >/{{
                              lang == "US" ? "monthly" : $t("Monthly")
                            }}</span
                          >
                        </div>
                      </div>
                      <div class="priceitembottom">
                        <div class="priceitem_content">
                          <p>{{ $t("40hoursofworkperweek") }}</p>
                          <p>
                            {{ $t("ClientsAndCandidatesNeed") }}
                          </p>
                          <p>
                            {{ $t("EachClientAndCandidate") }}
                          </p>
                          <p>
                            {{ $t("DelayedresponsesMakeTimely") }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="price_swlistitem price_swlistitemlie2"
                      v-if="planList.length && planList[0].length == 5"
                    >
                      <div class="priceitemtop">
                        <h2 class="priceitemtop_title">
                          {{ $t("FreeTrial") }}
                        </h2>
                        <div class="priceitemtop_desc" style="color: #0e756a">
                          {{ $t("Bindyourcreditcard") }}
                        </div>
                        <div class="priceitemtop_price">
                          <b>$</b><big>0</big
                          ><span>/{{ $t("FirstWeek") }}</span>
                        </div>
                        <!-- <div class="priceitemtop_getbtn">
                    <a
                      href="javascript:void(0)"
                      
                      >{{$t('Purchase1')}}</a
                    >
                  </div> -->

                        <div class="priceitemtop_botselect">
                          <h3>{{ $t("Botselection") }}：</h3>

                          <!-- <div class="priceitemtop_botflex">
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Sales") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Recruiter") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                      </div> -->
                        </div>
                      </div>
                      <div class="priceitembottom">
                        <div class="price_conswich">
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: !switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcorefeaturesofAISalesRep") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong> 1
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong> 33
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  30
                                  <a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong> 27
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  50<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Notsupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcoreAIRecruiter") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong> 1
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong> 33
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                30/{{ $t("Monthly") }}
                              </p>
                              <p>
                                <strong>{{ $t("Connection") }}:</strong> 27
                              </p>
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong> 50
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Notsupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="priceitemtop_getbtnflex">
                          <div class="priceitemtop_getbtn">
                            <a
                              href="javascript:void(0)"
                              @click="pay(planList[1][4], 4)"
                              >{{ $t("Continuetrial") }}</a
                            >
                          </div>
                        </div>

                        <!-- <div class="priceitemtop_getbtnflex">
                    <div class="priceitemtop_getbtn">
                      <a
                        href="javascript:void(0)"
                        
                        >{{$t('Purchase1')}}</a
                      >
                    </div>
                  </div> -->
                      </div>
                    </div>
                    <div class="price_swlistitem price_swlistitemlie3">
                      <div class="priceitemtop">
                        <h2 class="priceitemtop_title">{{ $t("LitePlan") }}</h2>
                        <div
                          v-if="planList[0] && planList[0][1]"
                          class="priceitemtop_desc"
                          v-html="
                            $t('ChooseEitherAISale100')
                              .replace('40', planList[0][1].max_connection_num)
                              .replace(
                                '100',
                                planList[0][1].max_conversation_num,
                              )
                          "
                        ></div>
                        <!-- <div class="priceitemtop_monthpr">
                      US${{
                        planList[0] && planList[0][1]
                          ? planList[0] && planList[0][1].price
                          : "0"
                      }}/{{ $t("month") }}
                    </div> -->
                        <div class="priceitemtop_price">
                          <b>US $</b
                          ><big>{{
                            planList[0] && planList[0][1]
                              ? planList[0] && planList[0][1].price
                              : "0"
                          }}</big
                          ><span>/{{ $t("month") }}</span>
                        </div>
                        <div class="priceitemtop_dally">
                          {{ $t("paidMonthly") }}
                        </div>
                        <!-- <div class="priceitemtop_getbtn">
                      <a
                        href="javascript:void(0)"
                        @click="pay(planList[0][1], 1)"
                        >{{ $t("Purchase1") }}
                      </a>
                    </div> -->

                        <div class="priceitemtop_botselect">
                          <h3>{{ $t("Botselection") }}：</h3>

                          <!-- <div class="priceitemtop_botflex">
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Sales") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Recruiter") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                      </div> -->
                        </div>
                      </div>
                      <div class="priceitembottom">
                        <div class="price_conswich">
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: !switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong> All
                                core
                                {{ $t("AllcorefeaturesofAISalesRep") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>

                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  80/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>

                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  <span :class="[lang]">
                                    100/{{ $t("monthly2")
                                    }}<a-icon
                                      type="exclamation-circle"
                                      style="margin: 0 5px"
                                    />
                                  </span>
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcoreAIRecruiter") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  80/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong> 40
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  100/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>

                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="priceitemtop_getbtnflex">
                          <div class="priceitemtop_getbtn">
                            <a
                              href="javascript:void(0)"
                              @click="pay(planList[0][1], 1)"
                              >{{ $t("Purchase1") }}</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="price_swlistitem price_swlistitemlie4">
                      <div class="pricehot">
                        <span>{{ $t("besetSeller") }}</span>
                      </div>

                      <div class="priceitemtop">
                        <h2 class="priceitemtop_title">{{ $t("ProPlan") }}</h2>
                        <div
                          v-if="planList[0] && planList[0][2]"
                          class="priceitemtop_desc"
                          v-html="
                            $t('ChooseEitherAISale500')
                              .replace('120', planList[0][2].max_connection_num)
                              .replace(
                                '500',
                                planList[0][2].max_conversation_num,
                              )
                          "
                        ></div>
                        <!-- <div class="priceitemtop_monthpr">
                      US${{
                        planList[0] && planList[0][2]
                          ? planList[0] && planList[0][2].price
                          : "0"
                      }}/{{ $t("month") }}
                    </div> -->
                        <div class="priceitemtop_price">
                          <b>US $</b
                          ><big>{{
                            planList[0] && planList[0][2]
                              ? planList[0] && planList[0][2].price
                              : "0"
                          }}</big
                          ><span>/{{ $t("month") }}</span>
                        </div>
                        <div class="priceitemtop_dally">
                          {{ $t("paidMonthly") }}
                        </div>
                        <!-- <div class="priceitemtop_getbtn">
                      <a
                        href="javascript:void(0)"
                        @click="pay(planList[0][2], 2)"
                        >{{ $t("Purchase1") }}</a
                      >
                    </div> -->

                        <div class="priceitemtop_botselect">
                          <h3>{{ $t("Botselection") }}：</h3>

                          <!-- <div class="priceitemtop_botflex">
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Sales") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Recruiter") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                      </div> -->
                        </div>
                      </div>
                      <div class="priceitembottom">
                        <div class="price_conswich">
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: !switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcorefeaturesofAISalesRep") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  240/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong> 120
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  500/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcoreAIRecruiter") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  240/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong> 120
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  500/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="priceitemtop_getbtnflex">
                          <div class="priceitemtop_getbtn">
                            <a
                              href="javascript:void(0)"
                              @click="pay(planList[0][2], 2)"
                              >{{ $t("Purchase1") }}</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="price_swlistitem price_swlistitemlie5"
                      :style="{ marginRight: lang == 'AR' ? '16px' : '0px' }"
                    >
                      <div class="priceitemtop">
                        <h2 class="priceitemtop_title">
                          {{ $t("PrimePlan") }}
                        </h2>
                        <div
                          class="priceitemtop_desc"
                          v-html="$t('GainunlimitedAccess')"
                        ></div>
                        <!-- <div class="priceitemtop_monthpr">
                      US${{
                        planList[0] && planList[0][3]
                          ? planList[0] && planList[0][3].price
                          : "0"
                      }}/{{ $t("month") }}
                    </div> -->
                        <div class="priceitemtop_price">
                          <b>US $</b
                          ><big>{{
                            planList[0] && planList[0][3]
                              ? planList[0] && planList[0][3].price
                              : "0"
                          }}</big
                          ><span>/{{ $t("month") }}</span>
                        </div>
                        <div class="priceitemtop_dally">
                          {{ $t("paidMonthly") }}
                        </div>
                        <!-- <div class="priceitemtop_getbtn">
                      <a
                        href="javascript:void(0)"
                        @click="pay(planList[0][3], 3)"
                        >{{ $t("Purchase1") }}</a
                      >
                    </div> -->

                        <div class="priceitemtop_botselect">
                          <h3>{{ $t("Botselection") }}：</h3>

                          <div class="priceitemtop_botflex">
                            <div class="priceitemtop_botflexitem noclick">
                              <span class="prbot_label">{{ $t("Sales") }}</span>
                              <span class="prbot_button"></span>
                            </div>
                            <div class="priceitemtop_botflexitem noclick">
                              <span class="prbot_label">{{
                                $t("Recruiter")
                              }}</span>
                              <span class="prbot_button"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="priceitembottom">
                        <div class="price_conswich">
                          <div class="price_conswichitem show">
                            <div class="priceitem_content">
                              <p>
                                <strong
                                  >{{ $t("CoreFeature") }}:
                                  <span style="color: #0e756a">{{
                                    $t("Allfeatures")
                                  }}</span></strong
                                >
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  480/{{ $t("monthly2") }}
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  <a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px; color: #0e756a"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong>
                            {{ $t("Unlimited") }}
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                {{ $t("Unlimited") }}
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  <a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px; color: #0e756a"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                          <div class="price_conswichitem">
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("Allfeatures") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                {{ $t("Unlimited") }}

                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  <a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px; color: #0e756a"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong>
                            {{ $t("Unlimited") }}
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                {{ $t("Unlimited") }}
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  <a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px; color: #0e756a"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="priceitemtop_getbtnflex">
                          <div class="priceitemtop_getbtn">
                            <a
                              href="javascript:void(0)"
                              @click="pay(planList[0][3], 3)"
                              >{{ $t("Purchase1") }}</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  title="Annually"
                  class="pric_switchingitem"
                  :class="{ show: !active }"
                >
                  <div class="pric_switchinglist">
                    <div
                      class="price_swlistitem price_swlistitemlie1"
                      :style="{ marginRight: lang == 'AR' ? 0 : '16px' }"
                      style="display: none"
                    >
                      <div class="priceitemtop">
                        <h2 class="priceitemtop_title">{{ $t("Manual") }}</h2>
                        <div class="priceitemtop_desc">
                          {{ $t("ReducecostsandImprove") }}
                        </div>
                        <div class="priceitemtop_price">
                          <b>$</b><big>5000</big
                          ><span
                            >/{{
                              lang == "US" ? "monthly" : $t("Monthly")
                            }}</span
                          >
                        </div>
                      </div>
                      <div class="priceitembottom">
                        <div class="priceitem_content">
                          <p>{{ $t("40hoursofworkperweek") }}</p>
                          <p>
                            {{ $t("ClientsAndCandidatesNeed") }}
                          </p>
                          <p>
                            {{ $t("EachClientAndCandidate") }}
                          </p>
                          <p>
                            {{ $t("DelayedresponsesMakeTimely") }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="price_swlistitem price_swlistitemlie2"
                      v-if="planList.length && planList[1].length == 5"
                    >
                      <div class="priceitemtop">
                        <h2 class="priceitemtop_title">
                          {{ $t("FreeTrial") }}
                        </h2>
                        <div class="priceitemtop_desc" style="color: #0e756a">
                          {{ $t("Bindyourcreditcard") }}
                        </div>
                        <div class="priceitemtop_price">
                          <b>$</b><big>0</big
                          ><span>/{{ $t("FirstWeek") }}</span>
                        </div>
                        <!-- <div class="priceitemtop_getbtn">
                    <a href="javascript:void(0)" >{{$t('Purchase1')}}</a>
                  </div> -->

                        <div class="priceitemtop_botselect">
                          <h3>{{ $t("Botselection") }}：</h3>

                          <!-- <div class="priceitemtop_botflex">
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Sales") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Recruiter") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                      </div> -->
                        </div>
                      </div>
                      <div class="priceitembottom">
                        <div class="price_conswich">
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: !switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcorefeaturesofAISalesRep") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong> 1
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong> 33
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  30
                                  <a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong> 27
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  50<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Notsupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcoreAIRecruiter") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong> 1
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong> 33
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  30/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong> 27
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  50/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Notsupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="priceitemtop_getbtnflex">
                          <div class="priceitemtop_getbtn">
                            <a
                              href="javascript:void(0)"
                              @click="pay(planList[0][4], 4)"
                              >{{ $t("Continuetrial") }}</a
                            >
                          </div>
                        </div>

                        <!-- <div class="priceitemtop_getbtnflex">
                    <div class="priceitemtop_getbtn">
                      <a href="javascript:void(0)" 
                        >{{$t('Purchase1')}}</a
                      >
                    </div>
                  </div> -->
                      </div>
                    </div>

                    <div class="price_swlistitem price_swlistitemlie3">
                      <div class="priceitemtop">
                        <h2 class="priceitemtop_title">{{ $t("LitePlan") }}</h2>
                        <div
                          v-if="planList[1] && planList[1][1]"
                          class="priceitemtop_desc"
                          v-html="
                            $t('litePlanDes')
                              .replace('99', planList[1][1].price)
                              .replace('40', planList[1][1].max_connection_num)
                          "
                        ></div>
                        <!-- <div class="priceitemtop_monthpr">
                      <span
                        >US$
                        {{
                          planList[1] && planList[1][1]
                            ? planList[1][1].original_price
                            : 0
                        }}/{{ $t("year") }}</span
                      >
                    </div> -->
                        <div class="priceitemtop_price">
                          <b>US $</b
                          ><big>{{
                            planList[1] && planList[1][1]
                              ? computedPrice(planList[1][1].price)
                              : 0
                          }}</big
                          ><span>/{{ $t("month") }}</span>
                        </div>
                        <div class="priceitemtop_dally">
                          {{ $t("paidAnnually") }}
                        </div>
                        <!-- <div class="priceitemtop_getbtn">
                      <a
                        href="javascript:void(0)"
                        @click="pay(planList[1][1], 1)"
                        >{{ $t("Purchase1") }}</a
                      >
                    </div> -->

                        <div class="priceitemtop_botselect">
                          <h3>{{ $t("Botselection") }}：</h3>

                          <!-- <div class="priceitemtop_botflex">
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Sales") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Recruiter") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                      </div> -->
                        </div>
                      </div>
                      <div class="priceitembottom">
                        <div class="price_conswich">
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: !switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcorefeaturesofAISalesRep") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  80/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong> 40
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  100/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcoreAIRecruiter") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  80/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong> 40
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  100/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="priceitemtop_getbtnflex">
                          <div class="priceitemtop_getbtn">
                            <a
                              href="javascript:void(0)"
                              @click="pay(planList[1][1], 1)"
                              >{{ $t("Purchase1") }}</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="price_swlistitem price_swlistitemlie4">
                      <div class="pricehot">
                        <span>{{ $t("besetSeller") }}</span>
                      </div>

                      <div class="priceitemtop">
                        <h2 class="priceitemtop_title">{{ $t("ProPlan") }}</h2>
                        <div
                          class="priceitemtop_desc"
                          v-if="planList[1] && planList[1][2]"
                          v-html="
                            $t('proPlanDes')
                              .replace('399', planList[1][2].price)
                              .replace('120', planList[1][2].max_connection_num)
                          "
                        ></div>
                        <!-- <div class="priceitemtop_monthpr">
                      <span
                        >US$
                        {{
                          planList[1] && planList[1][2]
                            ? planList[1][2].original_price
                            : 0
                        }}/{{ $t("year") }}</span
                      >
                      
                    </div> -->
                        <div class="priceitemtop_price">
                          <b>US $</b
                          ><big>{{
                            planList[1] && planList[1][2]
                              ? computedPrice(planList[1][2].price)
                              : 0
                          }}</big
                          ><span>/{{ $t("month") }}</span>
                        </div>
                        <div class="priceitemtop_dally">
                          {{ $t("paidAnnually") }}
                        </div>
                        <!-- <div class="priceitemtop_getbtn">
                      <a
                        href="javascript:void(0)"
                        @click="pay(planList[1][2], 2)"
                        >{{ $t("Purchase1") }}</a
                      >
                    </div> -->

                        <div class="priceitemtop_botselect">
                          <h3>{{ $t("Botselection") }}：</h3>

                          <!-- <div class="priceitemtop_botflex">
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Sales") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                        <div
                          class="priceitemtop_botflexitem"
                          :class="{ active: switchActive, disableCick }"
                          @click="switchHandler"
                        >
                          <span class="prbot_label">{{ $t("Recruiter") }}</span>
                          <span class="prbot_button"></span>
                        </div>
                      </div> -->
                        </div>
                      </div>
                      <div class="priceitembottom">
                        <div class="price_conswich">
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: !switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcorefeaturesofAISalesRep") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  240/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong> 120
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  500/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="price_conswichitem price_conswichitemqh"
                            :class="{ show: switchActive }"
                          >
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("AllcoreAIRecruiter") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  240/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong> 120
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  500/{{ $t("monthly2")
                                  }}<a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="priceitemtop_getbtnflex">
                          <div class="priceitemtop_getbtn">
                            <a
                              href="javascript:void(0)"
                              @click="pay(planList[1][2], 2)"
                              >{{ $t("Purchase1") }}</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="price_swlistitem price_swlistitemlie5"
                      :style="{ marginRight: lang == 'AR' ? '16px' : '0px' }"
                    >
                      <div class="priceitemtop">
                        <h2 class="priceitemtop_title">
                          {{ $t("PrimePlan") }}
                        </h2>
                        <div
                          class="priceitemtop_desc"
                          v-if="planList[1] && planList[1][3]"
                          v-html="
                            $t('primePlanDes').replace(
                              '799',
                              planList[1][3].price,
                            )
                          "
                        ></div>
                        <!-- <div class="priceitemtop_monthpr">
                      <span
                        >US$
                        {{
                          planList[1] && planList[1][3]
                            ? planList[1][3].original_price
                            : 0
                        }}/{{ $t("year") }}</span
                      >
                      
                    </div> -->
                        <div class="priceitemtop_price">
                          <b>US $</b
                          ><big>{{
                            planList[1] && planList[1][3]
                              ? computedPrice(planList[1][3].price)
                              : 0
                          }}</big
                          ><span>/{{ $t("month") }}</span>
                        </div>
                        <div class="priceitemtop_dally">
                          {{ $t("paidAnnually") }}
                        </div>
                        <!-- <div class="priceitemtop_getbtn">
                      <a
                        href="javascript:void(0)"
                        @click="pay(planList[1][3], 3)"
                        >{{ $t("Purchase1") }}</a
                      >
                    </div> -->

                        <div class="priceitemtop_botselect">
                          <h3>{{ $t("Botselection") }}：</h3>

                          <div class="priceitemtop_botflex">
                            <div class="priceitemtop_botflexitem noclick">
                              <span class="prbot_label">{{ $t("Sales") }}</span>
                              <span class="prbot_button"></span>
                            </div>
                            <div class="priceitemtop_botflexitem noclick">
                              <span class="prbot_label">{{
                                $t("Recruiter")
                              }}</span>
                              <span class="prbot_button"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="priceitembottom">
                        <div class="price_conswich">
                          <div class="price_conswichitem show">
                            <div class="priceitem_content">
                              <p>
                                <strong
                                  >{{ $t("CoreFeature") }}:
                                  <span style="color: #0e756a">{{
                                    $t("Allfeatures")
                                  }}</span></strong
                                >
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                <a-tooltip placement="topLeft">
                                  480/{{ $t("monthly2") }}
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  <a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px; color: #0e756a"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong>
                            {{ $t("Unlimited") }}
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                {{ $t("Unlimited")
                                }}<a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  <a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px; color: #0e756a"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                          <div class="price_conswichitem">
                            <div class="priceitem_content">
                              <p>
                                <strong>{{ $t("CoreFeature") }}:</strong>
                                {{ $t("Allfeatures") }}
                              </p>
                              <p>
                                <strong>{{ $t("Campaign") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("SearchResults") }}:</strong>
                                {{ $t("Unlimited") }}
                              </p>
                              <p>
                                <strong>{{ $t("ConnectionRequest") }}:</strong>
                                {{ $t("Unlimited") }}
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  <a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px; color: #0e756a"
                                  />
                                </a-tooltip>
                              </p>
                              <!-- <p>
                            <strong>{{ $t("Connection") }}:</strong>
                            {{ $t("Unlimited") }}
                          </p> -->
                              <p>
                                <strong>{{ $t("Conversation") }}:</strong>
                                {{ $t("Unlimited") }}
                                <a-tooltip placement="topLeft">
                                  <template slot="title">
                                    <span>{{ $t("landTips") }}</span>
                                  </template>
                                  <a-icon
                                    type="exclamation-circle"
                                    style="margin: 0 5px; color: #0e756a"
                                  />
                                </a-tooltip>
                              </p>
                              <p>
                                <strong>{{ $t("DashBoard") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong>{{ $t("HRExpert") }}:</strong>
                                {{ $t("Fullysupported") }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Proxycoverage").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Proxycoverage").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("Languagesupport").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("Languagesupport").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIConversationTuning").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIConversationTuning").split(":")[1] }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("SimulatedConversationTesting").split(
                                      ":",
                                    )[0]
                                  }}:</strong
                                >
                                {{
                                  $t("SimulatedConversationTesting").split(
                                    ":",
                                  )[1]
                                }}
                              </p>
                              <p>
                                <strong
                                  >{{
                                    $t("AIRequirementsAnalysis").split(":")[0]
                                  }}:</strong
                                >
                                {{ $t("AIRequirementsAnalysis").split(":")[1] }}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="priceitemtop_getbtnflex">
                          <div class="priceitemtop_getbtn">
                            <a
                              href="javascript:void(0)"
                              @click="pay(planList[1][3], 3)"
                              >{{ $t("Purchase1") }}</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="price_swlistitem right-box" :class="[lang]">
              <h4>{{ $t("EnterprisePlan") }}</h4>
              <div :class="[lang]" class="enterprise-description">
                {{ $t("Seamlesslyboost") }}
              </div>
              <div class="plan-selector" :class="[lang]">
                <div class="plan-selector-title">
                  {{ $t("ChooseYourTeamSize") }}
                </div>
                <div class="plan-buttons">
                  <button
                    class="plan-option-btn"
                    :class="{ active: currentIndex == 1 }"
                    @click="updateContactEmail('Starter', '3 accounts', 1)"
                    data-plan="starter"
                  >
                    <div class="plan-option-name">{{ $t("Starter") }}</div>
                    <div class="plan-option-accounts">
                      {{ $t("accounts").replace("*", 3) }}
                    </div>
                  </button>
                  <button
                    class="plan-option-btn recommended"
                    data-plan="growth"
                    :class="{ active: currentIndex == 2 }"
                    @click="updateContactEmail('Growth', '10 accounts', 2)"
                  >
                    <div class="plan-option-name">{{ $t("Growth") }}</div>
                    <div class="plan-option-accounts">
                      {{ $t("accounts").replace("*", 10) }}
                    </div>
                    <span class="popular">🔥 {{ $t("popular") }}</span>
                  </button>
                  <button
                    :class="{ active: currentIndex == 3 }"
                    class="plan-option-btn"
                    @click="updateContactEmail('Scale', '25 accounts', 3)"
                    data-plan="scale"
                  >
                    <div class="plan-option-name">{{ $t("Scale") }}</div>
                    <div class="plan-option-accounts">
                      {{ $t("accounts").replace("*", 25) }}
                    </div>
                  </button>
                  <button
                    class="plan-option-btn"
                    data-plan="enterprise"
                    :class="{ active: currentIndex == 4 }"
                    @click="updateContactEmail('Enterprise', '50+ accounts', 4)"
                  >
                    <div class="plan-option-name">{{ $t("Enterprise") }}</div>
                    <div class="plan-option-accounts">
                      {{ $t("accounts").replace("*", "50+") }}
                    </div>
                  </button>
                </div>
              </div>
              <div class="features-section" :class="[lang]">
                <div class="features-title">{{ $t("Corefeature") }}</div>
                <div
                  class="features-list collapsed"
                  :class="{
                    incluedFree: planList.length && planList[0].length == 5,
                    featureslist2: !(
                      planList.length && planList[0].length == 5
                    ),
                  }"
                >
                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("AllFeaturesIncluded") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("EnterpriseTraining") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("EnterpriseSingle") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("AccessManagement") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("AccesstoDesignated") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("UnlimitedConnectionRequests") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("UnlimitedConnections") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("APIAccess") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("AuditLogs") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("LinkedInAccess") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("MultilingualAICommunication") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("LocalizationofSystem") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("CustomizedBusiness") }}</span>
                  </div>

                  <div class="feature-item">
                    <span class="feature-icon">✓</span>
                    <span>{{ $t("TeamManagement") }}</span>
                  </div>
                </div>

                <div class="features-toggle">
                  <button class="features-toggle-btn" @click="toggleFeatures()">
                    <span class="toggle-text">{{ $t("ShowAllFeatures") }}</span>
                  </button>
                </div>
              </div>
              <div class="addons-section">
                <div class="addons-title">{{ $t("Availableadd") }}</div>
                <div class="addon-item">
                  <span class="addon-icon">+</span>
                  <span>{{ $t("Warmup") }}</span>
                </div>
                <div class="addon-item">
                  <span class="addon-icon">+</span>
                  <span>{{ $t("ProxyPool") }}</span>
                </div>
                <div class="addon-item">
                  <span class="addon-icon">+</span>
                  <span>{{ $t("Rolebasedpermissions") }}</span>
                </div>
                <div class="addon-item">
                  <span class="addon-icon">+</span>
                  <span>{{ $t("Audittrail") }}</span>
                </div>
              </div>
              <div class="contact-btn-wrapper">
                <a :href="mailInfo" class="contact-btn">
                  {{ $t("Contactus") }}
                </a>
              </div>
            </div>
          </div>
          <div class="free-trial-note">
            Free trials are for first-time customers only.
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
import Step from "./Step.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      step: 1,
      active: false,
      current: 0,
      switchActive: false,
      planList: [],
      loading: true,
      disableCick: false,
      currentIndex: 1,
      mailInfo: "",
    };
  },
  i18n: require("../i18n"),
  computed: {
    ...mapGetters("account", ["user"]),
  },
  watch: {
    lang() {
      this.toggleFeatures();
      this.toggleFeatures();
    },
  },
  created() {
    let { campaign_type } = this.$route.query;
    // this.switchActive = campaign_type == 1 || !campaign_type ? false : true;
    if (campaign_type == 1 || campaign_type == 2) {
      this.disableCick = true;
    }

    Promise.all([this.getPlanList(2), this.getPlanList(3)])
      .then((res) => {
        this.planList = res;
        this.loading = false;
      })
      .catch((e) => {
        console.log(e);
        this.loading = false;
      });
  },
  mounted() {
    this.updateContactEmail("Starter", "3 accounts", 1);
  },
  components: { Step },
  methods: {
    updateContactEmail(planName, accounts, current) {
      this.currentIndex = current;

      // Email subject
      const subject = `Enterprise Plan Inquiry - ${planName} (${accounts})`;

      // Email body template
      const body = `Dear StrategyBrain Team,
  I am interested in learning more about your Enterprise Plan and would like to request additional information.
  
   Inquiry details
  Selected Plan: ${planName} Plan
  
  Contact information
  Company Name: [Your Company Name]
  Your Name: [Your Full Name]
  Email: [Your Email Address]
  Phone: [Your Phone Number]
  
  I would appreciate the opportunity to discuss:
  • Detailed pricing for the ${planName} plan
  • Implementation timeline and onboarding process
  • Available add-ons and customization options
  • Service level agreements (SLA)
  • Data security and compliance measures
  
  Please let me know your availability for a call or demo at your earliest convenience.
  Thank you for your time and consideration.
  Best regards,
  [Your Name]`;

      // Encode the email components
      const encodedSubject = encodeURIComponent(subject);
      const encodedBody = encodeURIComponent(body);
      // Update the mailto link
      this.mailInfo = `mailto:info@strategybrain.ca?subject=${encodedSubject}&body=${encodedBody}`;
    },
    toggleFeatures() {
      const featuresList = document.querySelector(".features-list");
      const toggleText = document.querySelector(".toggle-text");

      if (featuresList.classList.contains("collapsed")) {
        featuresList.classList.remove("collapsed");
        // toggleText.textContent = "Show Less ▲";
        toggleText.textContent = this.$t("ShowLess");
      } else {
        featuresList.classList.add("collapsed");
        // toggleText.textContent = "Show All Features ▼";
        toggleText.textContent = this.$t("ShowAllFeatures");
      }
    },
    computedPrice(price) {
      return Math.round(price / 12);
    },
    formatEmail() {
      return this.$t("instanthelp").replace(
        "info@strategybrain.com",
        '<a href="mailto:info@strategybrain.com">info@strategybrain.com</a>',
      );
    },
    formatEmail2() {
      return this.$t("Notsatisfied").replace(
        "info@strategybrain.com",
        '<a style="color:#fff" href="mailto:info@strategybrain.com">info@strategybrain.com</a>',
      );
    },
    tabHandler() {
      this.active = !this.active;
    },
    goplan2() {
      this.$route.push({
        path: "/userSetting/planStep2",
        query: this.$route.query,
      });
    },
    switchHandler() {
      if (this.disableCick) {
        return;
      }
      this.switchActive = !this.switchActive;
    },
    pay(obj, type) {
      let { campaign_type } = this.$route.query;
      this.writeLog(
        "plan",
        this.active ? "monthly" : "annual",
        type == 1 ? "lite" : type == 2 ? "pro" : "prime",
      );
      let obj2 = {
        ...this.$route.query,
        duration_type: this.active ? 2 : 3,
        type,
        campType: campaign_type,
      };
      if (type == 4 && obj2.campaign_type && !this.user.linkedin_count) {
        delete obj2.campType;
        delete obj2.campaign_type;
      }

      this.$router.push({
        path: "/setting/userSetting/planStep2",
        query: obj2,
        // query: {
        //   ...this.$route.query,
        //   duration_type: this.active ? 2 : 3,
        //   type,
        //   campType: campaign_type,
        // },
      });
      // this.$router.push({
      //   path: "/setting/userSetting/planStep2",
      //   query: {
      //     ...obj,
      //     ...this.$route.query,
      //     duration_type: this.active ? 2 : 3,
      //     type,
      //     campType: campaign_type,
      //     //campaign_type: all ? 3 : this.switchActive ? 2 : 1,
      //   },
      // });
    },
    getPlanList(type) {
      return new Promise((resolve, reject) => {
        this.$axios(
          "/payment/plan_list",
          {
            duration_type: type,
          },
          "post",
        )
          .then((res) => {
            if (res.code == 200) {
              resolve(res.data);
            } else {
              reject(res.msg);
            }
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  },
};
</script>
<style lang="less">
.customTip {
  .ant-tooltip-inner {
    background-color: #e4f5de !important;
    p {
      color: #e2dcdc;
    }
  }
}
</style>
<style lang="less" scoped>
@font-face {
  font-family: "Poppins";
  src: url("fonts/Poppins-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "Poppins-Bold";
  src: url("fonts/Poppins-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "Poppins-ExtraBold";
  src: url("fonts/Poppins-ExtraBold.ttf") format("truetype");
}
.chooseTips {
  text-align: center;
  .title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .subTitle {
    font-size: 14px;
  }
}
.baozhang {
  border-radius: 10px;
  background-color: #0e756a;
  padding: 12px;
  color: #fff;
  margin: 20px 0;
  .t1 {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .icon {
      font-size: 30px;
      color: #fff;
      margin-right: 6px;
    }
  }
  .t2 {
    margin-bottom: 0;
  }
  a {
    color: #fff !important;
  }
}

.home {
  margin-top: 50px;
  padding: 0px 30px 20px 30px;
  .tips {
    padding-top: 50px;
    padding-bottom: 12px;
    .tips-cont {
      height: 64px;
      line-height: 64px;
      background: #ffdfdf;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #ff0c0c;
      text-align: center;
      color: #ff0c0c;
      font-weight: bold;
      font-size: 16px;
      .icon {
        margin-right: 8px;
      }
    }
  }
  .wrap-step {
    padding-top: 53px;
    width: 90%;
    margin: 0 auto;
  }
  // .pricingbg{ padding:88px 0; position:relative; background:url(images/pricingbg.png) center center; background-size:cover;}
  .pricingbg .finddustomers_ellipse {
    top: 35%;
  }
  .pricingbg .finddustomers_ellipsebottom {
    bottom: 15%;
  }
  .pricing {
    position: relative;
    z-index: 2;
  }
  .pricing_container {
    box-shadow: 0px 4px 24px 0px #2d2d2d21;
    background: #ffffff;
    padding: 32px 16px 24px 16px;
    margin-top: 56px;
    border-radius: 16px;
  }
  .pricing_conflex {
    display: flex;
    justify-content: space-between;
  }
  .pricing_conleft {
    width: 220px;
  }
  .pricing_conright {
    // width: calc(100% - 244px);
    width: 100%;
  }

  .pricing_title {
    background: #d9d9d9;
    border-radius: 8px;
    padding: 10px;
    text-align: center;
  }
  .pricing_title h3 {
    font-size: 22px;
    font-family: "Poppins-Bold";
    line-height: 36px;
    white-space: nowrap;
  }
  .pricing_monthly {
    line-height: 56px;
    margin-top: 24px;
    color: #252525;
    font-size: 16px;
    text-align: center;
  }
  .pricing_pricecon {
    margin-top: 32px;
  }
  .pricing_pricecon h2 {
    font-size: 32px;
    font-weight: 900;
    line-height: 48px;
    color: #252525;
    font-family: "Poppins-ExtraBold";
  }
  .pricing_pricecon p {
    color: rgba(37, 37, 37, 0.6);
    font-size: 16px;
    font-weight: 400;
    margin-top: 8px;
    line-height: 24px;
    min-height: 48px;
  }
  .pricing_price {
    margin-top: 40px;
  }
  .pricing_price b {
    font-size: 24px;
    color: #252525;
    font-weight: 600;
    line-height: 36px;
  }
  .pricing_price big {
    color: #2d2d2d;
    font-size: 64px;
    font-weight: 900;
    line-height: 96px;
    font-family: "Poppins-ExtraBold";
  }
  .pricing_price span {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #252525;
  }

  .pricing_sales {
    margin-top: 42px;
  }
  .pricing_salesitem {
    background: #f9f9f9;
    border: #c5cfde 1px solid;
    padding: 24px 16px;
    border-radius: 8px;
    margin-bottom: 16px;
  }
  .pricing_salesitemtit {
    color: #252525;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
  .pricing_salesitemlist {
    margin-top: 16px;
  }
  .pricing_salesitemlist li {
    color: rgba(37, 37, 37, 0.6);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 8px;
    padding-left: 14px;
    position: relative;
  }
  .pricing_salesitemlist li:before {
    content: "";
    display: block;
    width: 6px;
    height: 6px;
    background: #2d2d2d;
    border-radius: 100%;
    position: absolute;
    left: 0;
    top: 8px;
  }
  .pricing_salesitemlist li:last-child {
    margin-bottom: 0;
  }

  .pricing_conright .pricing_title {
    background: #0e756a;
  }
  .pricing_conright .pricing_title h3 {
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pricing_conright .pricing_title h3:before {
    content: "";
    display: block;
    width: 36px;
    height: 36px;
    background: url(../../../assets/img/Subtract.svg) no-repeat;
    background-size: cover;
    margin-right: 8px;
  }

  .pricing_monthlyopan {
    width: 355px;
    display: flex;
    background: #f9f9f9;
    justify-content: space-between;
    border: #c5cfde 1px solid;
    border-radius: 16px;
    margin: 0 auto;
    cursor: pointer;
    position: relative;
  }
  .pricing_monthlyopan span {
    color: #252525;
    width: 40%;
    display: block;
    font-size: 16px;
    height: 56px;
    font-weight: 600;
    line-height: 56px;
    text-align: center;
    border-radius: 16px;
    position: relative;
    z-index: 2;
    transition: all 0.3s;
  }
  .pricing_monthlyopan span:nth-child(2) {
    color: #fff;
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pricing_monthlyopan span:nth-child(2):before,
  .pricehot span:before {
    margin-right: 3px;
    content: "";
    display: block;
    width: 14px;
    height: 17px;
    background: url(../../../assets/img/hot.png) no-repeat;
  }
  .pricing_monthlyopan:after {
    content: "";
    display: block;
    background: #0e756a;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0%;
    width: 60%;
    z-index: 1;
    border-radius: 16px;
    transition: all 0.3s;
  }
  .pricing_monthlyopan.active:after {
    right: 60%;
    width: 40%;
  }
  .pricing_monthlyopan.active span:nth-child(1) {
    color: #fff5dc;
  }
  .pricing_monthlyopan.active span:nth-child(2) {
    color: #252525;
  }

  .priveold {
    font-size: 16px;
    line-height: 24px;
  }
  .priveold b {
    color: #0e756a;
    text-decoration: line-through;
    margin-right: 10px;
  }
  .priveold span:nth-child(3) {
    display: none;
  }
  .priveold.hide b {
    display: none;
  }
  .priveold.hide span:nth-child(2) {
    display: none;
  }
  .priveold.hide span:nth-child(3) {
    display: inline-block;
  }

  .pricedaily {
    color: #252525;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    background: #f8fcf8;
    padding: 8px 30px;
    display: inline-block;
    border-radius: 16px;
    margin-top: -3px;
  }

  .pricing_conrflex {
    display: flex;
    justify-content: space-between;
  }
  .pricing_conrflexitem {
    width: 47.8%;
  }
  .pricing_conrflexitem .pricing_price big {
    color: #252525;
  }

  .linkedin_link {
  }
  .linkedin_link a,
  .linkedin_link select {
    padding: 5px 14px;
    display: block;
    font-size: 16px;
    background: #f9f9f9;
    line-height: 1.5;
    text-align: left;
    color: #252525;
    border-radius: 4px;
  }
  .linkedin_link a span {
    color: #ff3c3c;
  }

  .linkedin_btn {
    text-align: center;
    margin-top: 20px;
  }
  .linkedin_btn a {
    display: inline-block;
    background: #f9f9f9;
    color: #252525;
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
    padding: 8px 25px;
    border-radius: 16px;
  }

  .changepricetext span:nth-child(2) {
    display: none;
  }
  .changepricetext.active span:nth-child(1) {
    display: none;
  }
  .changepricetext.active span:nth-child(2) {
    display: inline-block;
  }

  .linkedin_link select {
    border: #c5cfde 1px solid;
    background: url(../../../assets/img/account_icon.png) no-repeat 97% center
      #f8fcf8;
    cursor: pointer;
    width: 100%;
    padding: 4px 16px;
  }
  .pricing_conrflexitem:nth-child(2) .pricing_price {
    margin-top: 13px;
  }
  .pricing_conrflexitem:nth-child(2) .pricing_sales {
    margin-top: 16px;
  }

  .changeprice big {
    transition: all 0.3s;
  }
  .changeprice big:nth-child(3),
  .changeprice.active big:nth-child(2) {
    display: none;
  }
  .changeprice.active big:nth-child(3) {
    display: inline-block;
  }

  .pricing_saleslist {
    margin-top: 32px;
  }

  /*20240809*/
  .pricing_conrflexitem:nth-child(1) .pricing_sales {
    margin-top: 0;
  }
  .pricing_conrflexitem:nth-child(2) {
    margin-top: 16px;
    padding: 16px;
    border-radius: 16px;
    background: #f8fcf8;
    box-shadow: 0px 0px 24px 0px #0e756a29;
  }
  .pricing_conrflexitem:nth-child(2) .pricing_pricecon {
    margin-top: 0;
  }
  .pricing_conrflexitem:nth-child(2) .pricing_price big {
    color: #0e756a;
  }
  .pricing_conrflexitem:nth-child(2) .linkedin_btn a {
    background: #0e756a;
    color: #fff;
  }
  .pricing_conrflexitem:nth-child(2) .pricing_salesitem {
    background: #fff;
  }

  /*Price åº•*/
  .pricedatabg {
    padding: 56px 0;
    background: #f8fcf8;
  }
  .pricedata {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .pricedataflex {
    display: flex;
    align-items: center;
  }
  .pricedatatit {
    color: #252525;
    font-size: 24px;
    font-weight: 600;
    line-height: 36px;
  }
  .pricedatalist {
  }
  .pricedatalist ul {
    display: flex;
  }
  .pricedatalist li {
    border-left: #0e756a 1px solid;
    padding-left: 32px;
    margin-left: 32px;
  }
  .pricedatalist span {
    color: #252525;
    font-size: 24px;
    font-weight: 600;
    line-height: 36px;
    display: block;
  }
  .pricedatalist span.num {
  }
  .pricedatalist span.unit {
    margin-top: 16px;
  }
  .pricedatarcon .linkedin_btn a {
    background: none;
  }
  .pricedatarcon h3 {
    color: #252525;
    font-size: 24px;
    font-weight: 600;
    line-height: 36px;
  }

  .pric_switchingall {
    // max-width: 1000px;
    margin: 0 auto;
    margin-top: 24px;
  }
  .pric_switchingall .pric_switchingitem {
    visibility: hidden;
    opacity: 0;
    height: 0;
    overflow: hidden;
    display: none;
  }
  .pric_switchingall .pric_switchingitem.show {
    opacity: 1;
    height: auto;
    visibility: visible;
    overflow: visible;
    display: block;
  }
  .pric_switchinglist {
    display: flex;
  }
  .pric_switchinglist .price_swlistitem {
    // width: 220px;
    margin-right: 16px;
    border: #c5cfde 1px solid;
    border-radius: 8px;
    padding: 28px 18px 104px;
    position: relative;
    flex: 1;
  }
  .pric_switchinglist .price_swlistitem:last-child {
    margin-right: 0;
  }
  .pric_switchinglist .price_swlistitemlie1 {
    background: #f9f9f9;
  }
  .pric_switchinglist .price_swlistitemlie2 {
    background: #f8fcf8;
  }
  .pric_switchinglist .price_swlistitemlie3 {
    background: #f8fcf8;
  }
  .pric_switchinglist .price_swlistitemlie4 {
    background: #f8fcf8;
    border-color: #0e756a;
    box-shadow: 0px 4px 16px 0px #0000003d;
  }
  .pric_switchinglist .price_swlistitemlie5 {
    background: #f8fcf8;
  }

  .pricehot {
    background: #ff7426;
    border: #ed3e00 1px solid;
    width: 133px;
    height: 32px;
    text-align: center;
    border-radius: 16px;
    position: absolute;
    right: -8px;
    top: -16px;
    z-index: 2;
  }
  .pricehot span {
    color: #fff;
    display: flex;
    height: 100%;
    font-weight: 600;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    justify-content: center;
  }

  .price_swlistitem .priceitemtop {
    border-bottom: 1px dashed #c5cfde;
    padding-bottom: 16px;
    // min-height: 430px;
  }
  .price_swlistitem .priceitemtop .priceitemtop_title {
    font-size: 24px;
    font-weight: 900;
    line-height: 36px;
    color: #252525;
    font-family: "Poppins-ExtraBold";
  }
  .price_swlistitem .priceitemtop .priceitemtop_desc {
    margin-top: 16px;
    font-size: 14px;
    line-height: 21px;
    color: rgba(37, 37, 37, 0.6);
    min-height: 105px;
  }
  .price_swlistitem .priceitemtop .priceitemtop_desc span {
    color: #6caba3;
  }
  .price_swlistitem .priceitemtop .priceitemtop_monthpr {
    font-size: 14px;
    line-height: 21px;
    color: #656b61;
    margin-top: 3px;
  }
  .price_swlistitem .priceitemtop .priceitemtop_monthpr span:nth-child(1) {
    text-decoration: line-through;
  }
  .price_swlistitem .priceitemtop .priceitemtop_monthpr span:nth-child(2) {
    color: #0e756a;
    margin-left: 8px;
  }
  .price_swlistitem .priceitemtop .priceitemtop_dally {
    font-size: 14px;
    line-height: 21px;
    color: #252525;
  }

  .price_swlistitem.price_swlistitemlie1 .priceitemtop .priceitemtop_price,
  .price_swlistitem.price_swlistitemlie2 .priceitemtop .priceitemtop_price {
    margin-top: 24px;
  }

  .priceitemtop_price b {
    font-size: 14px;
    color: #252525;
    font-weight: 600;
    line-height: 21px;
  }
  .priceitemtop_price big {
    color: #2d2d2d;
    font-size: 32px;
    font-weight: 900;
    line-height: 48px;
    font-family: "Poppins-ExtraBold";
  }
  .priceitemtop_price span {
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    color: #252525;
  }

  .price_swlistitem .priceitemtop_getbtn {
    text-align: center;
    margin-top: 37px;
  }
  .price_swlistitem .priceitemtop_getbtn a {
    display: inline-block;
    background: #ff7426;
    border: #ff7426 1px solid;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
    padding: 8px 24px;
    border-radius: 16px;
    white-space: nowrap;
  }

  .price_swlistitem.price_swlistitemlie2 .priceitemtop_getbtn {
    margin-top: 60px;
  }
  .price_swlistitem.price_swlistitemlie2 .priceitemtop_getbtn a {
    background: #fff;
    border: #ff7426 1px solid;
    color: #ff7426;
  }

  .price_swlistitem .priceitembottom .priceitemtop_getbtnflex {
    position: absolute;
    width: 100%;
    bottom: 32px;
    left: 0%;
    display: flex;
    justify-content: center;
  }
  .price_swlistitem .priceitembottom .priceitemtop_getbtn {
    margin: 0;
  }

  .priceitemtop_botselect {
    display: none;
    margin-top: 24px;
  }
  .priceitemtop_botselect h3 {
    font-size: 14px;
    line-height: 21px;
    color: #252525;
    font-weight: 600;
  }
  .priceitemtop_botflex {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
  }
  .priceitemtop_botflex .priceitemtop_botflexitem {
    display: flex;
    align-items: center;
  }
  .priceitemtop_botflex span {
    cursor: pointer;
  }
  .priceitemtop_botflex .prbot_label {
    font-size: 14px;
    line-height: 21px;
    color: #252525;
    font-weight: 600;
    margin-right: 4px;
  }
  .priceitemtop_botflex .prbot_button {
    display: block;
    width: 32px;
    height: 18px;
    background: #0e756a;
    border-radius: 33px;
    position: relative;
  }
  .priceitemtop_botflex .prbot_button:after {
    content: "";
    display: block;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #fff;
    position: absolute;
    right: 2px;
    top: 2px;
    transition: all 0.3s;
  }
  .priceitemtop_botflex .priceitemtop_botflexitem:nth-child(2) .prbot_button {
    background: #cecece;
  }
  .priceitemtop_botflex
    .priceitemtop_botflexitem:nth-child(2)
    .prbot_button:after {
    right: calc(100% - 16px);
  }

  .priceitemtop_botflex
    .priceitemtop_botflexitem.active:nth-child(1)
    .prbot_button {
    background: #cecece;
  }
  .priceitemtop_botflex
    .priceitemtop_botflexitem.active:nth-child(1)
    .prbot_button:after {
    right: calc(100% - 16px);
  }
  .priceitemtop_botflex
    .priceitemtop_botflexitem.active:nth-child(2)
    .prbot_button {
    background: #0e756a;
  }
  .priceitemtop_botflex
    .priceitemtop_botflexitem.active:nth-child(2)
    .prbot_button:after {
    right: 2px;
  }

  .priceitemtop_botflex .noclick .prbot_button,
  .priceitemtop_botflex
    .priceitemtop_botflexitem.noclick:nth-child(2)
    .prbot_button,
  .priceitemtop_botflex
    .priceitemtop_botflexitem.active.noclick:nth-child(1)
    .prbot_button {
    background: #b2d4ce;
  }
  .priceitemtop_botflex
    .priceitemtop_botflexitem.noclick:nth-child(2)
    .prbot_button:after,
  .priceitemtop_botflex
    .priceitemtop_botflexitem.active.noclick:nth-child(1)
    .prbot_button:after {
    right: 2px;
  }

  .price_swlistitem .priceitembottom {
    padding-top: 16px;
  }
  .price_conswich {
  }
  .price_conswich .price_conswichitem {
    visibility: hidden;
    opacity: 0;
    height: 0;
    overflow: hidden;
    transition: all 0.5s;
  }
  .price_conswich .price_conswichitem.show {
    opacity: 1;
    height: auto;
    visibility: visible;
  }
  .price_swlistitem .priceitembottom .priceitem_content p {
    font-size: 14px;
    line-height: 21px;
    color: #7a7a7a;
    margin-bottom: 16px;
  }
  .price_swlistitem.price_swlistitemlie1 .priceitembottom .priceitem_content p {
    color: #252525;
  }
  .price_swlistitem .priceitembottom .priceitem_content p:last-child {
    margin-bottom: 0;
  }
  .price_swlistitem .priceitembottom .priceitem_content p strong {
    color: #252525;
  }
  .price_swlistitem .priceitembottom .priceitem_content p span {
    color: #0e756a;
    font-weight: 600;
  }

  @media (max-width: 1280px) {
    .pric_switchinglist .price_swlistitem {
      width: 18.4%;
      margin-right: 2%;
    }
  }
  @media (max-width: 1160px) {
    .pric_switchinglist {
      flex-wrap: wrap;
    }
    .pric_switchinglist .price_swlistitem {
      width: 32%;
      margin-bottom: 30px;
    }
    .pric_switchinglist .price_swlistitem:nth-child(3n) {
      margin-right: 0;
    }
  }
  @media (max-width: 768px) {
    .pricing_conright {
      margin-top: 20px;
    }
    .pric_switchinglist {
      flex-wrap: wrap;
    }
    .pric_switchinglist .price_swlistitem {
      margin-bottom: 20px;
      width: 100%;
      margin-right: 0;
      padding: 20px 8px;
    }
    .price_swlistitem .priceitemtop .priceitemtop_desc,
    .price_swlistitem .priceitemtop {
      min-height: inherit;
    }
    .price_swlistitem.price_swlistitemlie1 .priceitemtop .priceitemtop_price,
    .price_swlistitem.price_swlistitemlie2 .priceitemtop .priceitemtop_price {
      margin-top: 0;
    }
    .price_swlistitem .priceitembottom .priceitemtop_getbtnflex {
      position: static;
      margin-top: 20px;
    }
    .price_swlistitem .priceitemtop_getbtn,
    .price_swlistitem.price_swlistitemlie2 .priceitemtop_getbtn {
      margin-top: 20px;
    }
  }

  h3 {
    margin-bottom: 0;
  }
  /deep/.ant-steps-item-title::after {
    background-color: #e1e1e1;
    height: 2px;
  }
  /deep/.ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: #e1e1e1;
  }
  /deep/.ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: #e1e1e1;
  }
}
.disableCick {
  opacity: 0.5;
}
.wrap-btn {
  width: 1090px;
  margin: 0 auto;
  display: flex;
  .pricing_monthly {
    width: 100%;
    flex: 1;
  }
  .enterprise-header {
    margin-left: 20px;
    width: 330px;
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    color: white;
    border-radius: 12px;
    text-align: center;
    margin: 24px 0;
    position: relative;
    overflow: hidden;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .enterprise-header::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    animation: shine 3s infinite;
  }

  @keyframes shine {
    0%,
    100% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(-30%, -30%);
    }
  }

  .enterprise-header h2 {
    font-size: 24px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: relative;
    z-index: 1;
    color: #fff;
    margin: 0;
  }
  .enterprise-badge {
    display: inline-block;
    background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
    color: #1f2937;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    margin-left: 10px;
    text-transform: uppercase;
  }
}
.main-wrap {
  width: 1090px;
  margin: 0 auto;
  display: flex;
  .left-box {
    flex: 1;
    width: 100%;
  }

  .right-box {
    height: 100%;
    border: #c5cfde 1px solid;
    border-radius: 8px;
    padding: 28px 18px 104px;
    background: #f8fcf8;
    position: relative;
    margin-top: 24px;
    h4 {
      font-size: 24px;
      font-weight: 900;
      line-height: 36px;
      color: #252525;
      font-family: "Poppins-ExtraBold";
      text-align: left;
      margin-bottom: 25px;
    }
    width: 330px;
    margin-left: 20px;
    .enterprise-description {
      font-size: 14px;
      color: #6b7280;
      line-height: 1.7;
      text-align: left;
      margin-bottom: 22px;
      padding: 20px;
      background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
      border-radius: 12px;
      border-left: 4px solid #2d7a6e;
    }

    .plan-selector {
      margin-bottom: 22px;
      text-align: left;
    }

    .plan-selector-title {
      font-size: 16px;
      font-weight: 600;
      color: #1f2937;
      margin-bottom: 26px;
      text-align: left;
    }

    .plan-buttons {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }

    .plan-option-btn {
      padding: 16px 20px;
      border: 2px solid #e5e7eb;
      border-radius: 12px;
      background: white;
      cursor: pointer;
      transition: all 0.3s ease;
      text-align: center;
      position: relative;
    }

    .plan-option-btn:hover {
      border-color: #2d7a6e;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(45, 122, 110, 0.15);
    }

    .plan-option-btn.active {
      border-color: #2d7a6e;
      background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
      box-shadow: 0 4px 12px rgba(45, 122, 110, 0.2);
    }

    .plan-option-btn.active::before {
      content: "✓";
      position: absolute;
      top: 8px;
      right: 8px;
      width: 20px;
      height: 20px;
      background: #2d7a6e;
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
    }

    .plan-option-btn.recommended {
      border-color: #ff6b35;
    }

    .plan-option-btn.recommended span {
      display: inline-block;
      position: absolute;
      top: -10px;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(135deg, #ff6b35 0%, #ff8c5a 100%);
      color: white;
      padding: 4px 12px;
      border-radius: 12px;
      font-size: 11px;
      font-weight: 600;
      white-space: nowrap;
    }

    .plan-option-name {
      font-size: 18px;
      font-weight: 700;
      color: #1f2937;
      margin-bottom: 4px;
    }

    .plan-option-accounts {
      font-size: 14px;
      color: #6b7280;
    }

    /* Features Section */
    .features-section {
      margin-bottom: 10px;
    }

    .features-title {
      font-size: 16px;
      font-weight: 600;
      color: #1f2937;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 2px solid #e5e7eb;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .features-title::before {
      content: "⭐";
      font-size: 18px;
    }

    .feature-item {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      margin-bottom: 10px;
      font-size: 14px;
      color: #7a7a7a;
      line-height: 1.6;
    }

    .feature-icon {
      color: #2d7a6e;
      font-weight: bold;
      flex-shrink: 0;
      margin-top: 2px;
      font-size: 14px;
    }

    .addons-section {
      margin-bottom: 24px;
      padding: 16px;
      background: #fef3f2;
      border-radius: 12px;
      border: 1px solid #fecaca;
    }

    .addons-title {
      font-size: 15px;
      font-weight: 600;
      color: #ff6b35;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .addons-title::before {
      content: "🎁";
      font-size: 16px;
    }

    .addon-item {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 6px;
      font-size: 13px;
      color: #6b7280;
      padding-left: 8px;
    }

    .addon-icon {
      color: #ff6b35;
      font-size: 14px;
      font-weight: bold;
    }

    /* Contact Button */
    .contact-btn-wrapper {
      text-align: center;
      position: absolute;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 32px;

      display: flex;

      justify-content: center;
    }

    .contact-btn {
      display: inline-block;
      background: #ff7426;
      border: #ff7426 1px solid;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      line-height: 30px;
      padding: 8px 24px;
      border-radius: 16px;
      white-space: nowrap;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      width: 100%;
      justify-content: center;
    }

    .contact-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);
    }

    .contact-btn::after {
      content: "→";
      font-size: 20px;
      transition: transform 0.3s ease;
    }

    .contact-btn:hover::after {
      transform: translateX(4px);
    }

    .contact-info {
      text-align: center;
      margin-top: 16px;
      font-size: 13px;
      color: #9ca3af;
    }

    .contact-info a {
      color: #2d7a6e;
      text-decoration: none;
      font-weight: 500;
    }

    .contact-info a:hover {
      text-decoration: underline;
    }

    .note {
      text-align: center;
      color: #9ca3af;
      font-size: 12px;
      margin-top: 20px;
      padding: 12px;
      background: #f9fafb;
      border-radius: 8px;
    }

    /* Expandable Features */
    .features-toggle {
      text-align: center;
      margin-top: 12px;
    }

    .features-toggle-btn {
      background: none;
      border: none;
      color: #2d7a6e;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      padding: 8px 16px;
      border-radius: 6px;
      transition: all 0.3s ease;
    }

    .features-toggle-btn:hover {
      background: #f0fdf4;
    }

    // .features-list.collapsed .feature-item:nth-child(n + 6) {
    //   display: none;
    // }
  }
  .right-box.AR {
    margin-left: 0;
    margin-right: 20px;
  }
}
.featureslist2.collapsed .feature-item:nth-child(n + 3) {
  display: none;
}
.free-trial-note {
  margin-top: 24px;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  color: #6b7280;
}
.incluedFree {
  .priceitemtop_desc {
    height: 147px;
  }
  .features-list.collapsed .feature-item:nth-child(n + 9) {
    display: none;
  }
  .plan-selector-title {
    margin-bottom: 20px !important;
  }
  big {
    font-size: 22px !important;
  }
  .plan-selector {
    margin-bottom: 32px !important;
  }
  .enterprise-description {
    margin-bottom: 30px;
  }
  .features-section {
    margin-bottom: 20px;
  }
  .addons-section {
    margin-bottom: 22px;
  }
}
</style>
